import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск детали при кроссировании.
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'users'];
  }

  initialize() {
    this.timeout = null;
  }

  connect() {
    const that = this;
    document.body.addEventListener('click', () => { that.usersTarget.style.display = 'none'; });

    this.inputTarget.addEventListener('keyup', (e) => this.searchUsers(e));
  }

  disconnect() {
    this.inputTarget.removeEventListener('keyup', (e) => this.searchUsers(e));
  }

  renderNotFound(query) {
    this.usersTarget.innerHTML = `<div class="dropdown-item">Ни один пользователь по запросу «${query}» не найден.</div>`;
    this.usersTarget.style.display = null;
  }

  renderUser(user, cursorPosition) {
    return `
      <a class="dropdown-item" data-action="click->office--warranty--search-user#selectUser"
       data-user-email="${user.email}" data-cursor-position="${cursorPosition}">
        ${user.email} ${user.fname || ''} ${user.iname || ''} ${user.oname || ''}
      </a>
    `;
  }

  renderUsers(users, cursorPosition) {
    const result = [];
    for (const user of users) {
      result.push(this.renderUser(user, cursorPosition));
    }
    this.usersTarget.innerHTML = result.join('');
    this.usersTarget.style.display = null;
  }

  searchUsers(e) {
    const cursorPosition = e.target.selectionStart;
    const textAreaWords = this.inputTarget.value.substr(0, cursorPosition).split(/[\s,;!]/);
    const query = textAreaWords[textAreaWords.length - 1];

    if (query[0] !== '<' || query.search(/[\s,;!]/) > 0) {
      this.usersTarget.style.display = 'none';
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (query.length > 0) {
        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/office/users/search_by_email?q=${query.substr(1)}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderUsers(data, cursorPosition);
            } else {
              that.renderNotFound(query);
            }
          },
          error: () => {
            alert('Ошибка при попытке найти пользователей по вашему запросу');
          },
        });
      }
    }, 500);
  }

  selectUser(event) {
    const cursorPosition = event.target.dataset.cursorPosition;
    const valueBeforeCursor = this.inputTarget.value.substr(0, cursorPosition);
    const valueAfterCursor = this.inputTarget.value.substr(cursorPosition);
    const queries = valueBeforeCursor.split('<');
    const query = queries[queries.length - 1];
    const newCursorPosition = cursorPosition - query.length + event.target.dataset.userEmail.length + 1;
    this.inputTarget.value = this.inputTarget.value.substr(0, cursorPosition - query.length) +
      event.target.dataset.userEmail + '>' + valueAfterCursor;

    this.usersTarget.style.display = 'none';
    this.inputTarget.focus();
    this.inputTarget.setSelectionRange(newCursorPosition, newCursorPosition);
  }
}
